import { render, staticRenderFns } from "./TopPickChange.vue?vue&type=template&id=345d7358&scoped=true"
import script from "./TopPickChange.vue?vue&type=script&lang=js"
export * from "./TopPickChange.vue?vue&type=script&lang=js"
import style0 from "./TopPickChange.vue?vue&type=style&index=0&id=345d7358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d7358",
  null
  
)

export default component.exports